<div class="estaSeguro">
  <h3>{{ message }}</h3>

  <div class="buttonsDialog mt-2">
    <button class="btnCancelar" debounceClick (debounceClick)="cerrarDialogo()">Cancelar</button>
    &nbsp;
    <button class="btnValid" debounceClick (debounceClick)="executeAction()">Aceptar</button>
  </div>
</div>
